import { ParticipantsView } from '../constants';
export const initialState = {
    participantsView: ParticipantsView.Grid,
    isGridViewOpen: true,
    actionsParticipantId: null,
};
export const callMobileReducer = (state = initialState, action = {}) => {
    const { type, payload } = action;
    switch (type) {
        case 'CALL-MOBILE/SET_PARTICIPANTS_VIEW':
            return { ...state, participantsView: payload };
        case 'CALL-MOBILE/TOGGLE_ACTIONS':
            return { ...state, actionsParticipantId: payload };
        case 'CALL-MOBILE/TOGGLE_GRID_VIEW':
            const isGridViewOpen = payload ?? !state.isGridViewOpen;
            return { ...state, isGridViewOpen };
        default:
            return state;
    }
};
export default callMobileReducer;
